import { render } from "./BoUsers.vue?vue&type=template&id=b8d6dd0e&scoped=true&ts=true"
import script from "./BoUsers.vue?vue&type=script&lang=ts"
export * from "./BoUsers.vue?vue&type=script&lang=ts"

import "./BoUsers.vue?vue&type=style&index=0&id=b8d6dd0e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d6dd0e"]])

export default __exports__